import { TableActions } from '@core/components/Table';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelarBaixaIcon from 'app/assets/icon/cancelarBaixaIcon';
import * as Actions from 'app/store/actions';
import React from 'react';
import { FaCloudDownloadAlt, FaHandHoldingUsd } from 'react-icons/fa';
import { MdRepeat } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useContasPagar } from '../store';
import { ContasPagarAction, ContasPagarUtil } from '../store/contasPagarAction';
import { RecorrenciaAction, useRecorrencia } from '../store/recorrencia';

const ContasPagarBotao = () => {
  const [state, dispatch] = useContasPagar();
  const [, dispatchRecorrencia] = useRecorrencia();

  const { selecionados, tipoSelecao } = state;
  const idsSelecionados = selecionados?.map((contasPagar) => contasPagar.id);

  const dispatchMessage = useDispatch();
  const apiUtils = useApiUtils(dispatchMessage, Actions);

  const warningMessage = 'É necessário selecionar um registro para concluir a ação.';

  const excluir = () => {
    ContasPagarAction.excluir(dispatch, idsSelecionados, state.requestParams, state.tipoSelecao);
  };

  const cadastrar = () => {
    dispatch(ContasPagarAction.cadastrar());
  };

  const importarPlanilha = () => {
    dispatch(ContasPagarAction.abrirImportModal());
  };

  const selecionarAoMenosUmaContaParcialMsg = () => {
    apiUtils.handleApiError({
      response: {
        data: {
          message: 'Não é possível selecionar mais de uma conta a pagar quando há uma baixa parcial.',
        },
      },
    });
  };

  const baixarConta = () => {
    if (selecionados && selecionados.length > 0) {
      if (selecionados?.length > 1 && selecionados?.some((cp) => cp.situacao === 'PARCIAL')) {
        selecionarAoMenosUmaContaParcialMsg();
      } else {
        ContasPagarAction.requestBaixa(dispatch, selecionados);
      }
    } else {
      dispatch(ContasPagarAction.warning(warningMessage));
    }
  };

  const cancelarBaixa = () => {
    if (selecionados && selecionados.length > 0) {
      ContasPagarAction.cancelarBaixas(dispatch, selecionados, state.requestParams, state.tipoSelecao);
    } else {
      dispatch(ContasPagarAction.warning(warningMessage));
    }
  };

  const despesasRegulares = () => {
    dispatchRecorrencia(RecorrenciaAction.visualizarRecorrencia());
  };

  const actions = [
    {
      icon: <MdRepeat />,
      name: 'despesasRegulares',
      tooltip: 'Despesas regulares',
      show: state.somatorios?.quantidadeContasAgendadas > 0,
      onClick: despesasRegulares,
    },
    {
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: 'Excluir',
      show:
        ContasPagarUtil.verificarExibicaoBotaoExcluir(tipoSelecao, selecionados) && permissaoUtils.contaPagar().excluir,
      onClick: excluir,
    },
    {
      icon: <CancelarBaixaIcon />,
      name: 'cancelarBaixa',
      tooltip: 'Cancelar baixa',
      show: ContasPagarUtil.verificarExibicaoBotaoCancelarBaixa(tipoSelecao, selecionados),
      onClick: cancelarBaixa,
    },
    {
      icon: <FaHandHoldingUsd />,
      name: 'baixar',
      tooltip: 'Baixar',
      show: ContasPagarUtil.verificarExibicaoBotaoBaixar(tipoSelecao, selecionados),
      onClick: baixarConta,
    },
    {
      icon: <FaCloudDownloadAlt />,
      name: 'importar',
      tooltip: 'Importar planilha',
      show: permissaoUtils.contaPagar().cadastrar,
      onClick: importarPlanilha,
    },
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.contaPagar().cadastrar,
      onClick: cadastrar,
    },
  ];
  return <TableActions className={'stepFabContaPagar'} actions={actions} />;
};

export default ContasPagarBotao;
